module.exports = __webpack_public_path__ + "img/fbc0b18d882a2d811b2d5eee241c1d28.png";